import React from 'react';
import { Paper, List, ListItem, ListItemText, Badge, Typography, Box } from '@mui/material';

export default function AgentNotifications({ items = [], onItemClick }) {
  const unread = items.filter((i) => !i.read).length;

  return (
    <Paper sx={{ p: 2, borderRadius: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6">Notifications</Typography>
        <Badge color="error" badgeContent={unread} />
      </Box>

      <List dense>
        {items.length === 0 && <Box sx={{ py: 3, textAlign: 'center', color: 'text.secondary' }}>No notifications</Box>}
        {items.map((it) => (
          <ListItem
            key={it.id}
            button={Boolean(onItemClick)}
            onClick={() => onItemClick?.(it)}
            sx={{
              background: it.read ? 'transparent' : '#f5f8ff',
              mb: 1,
              borderRadius: 1,
              cursor: onItemClick ? 'pointer' : 'default',
            }}
          >
            <ListItemText primary={it.title} secondary={it.time} />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
}
